import React from "react";
import "../../styles/loader.scss";

const Loader = () => {
  return (
    <div className="loader_container">
      {" "}
      <span className="loader"></span>
    </div>
  );
};

export default Loader;
